<template>
  <div>
    <v-text-field
      v-model="search"
      rounded-sm
      hide-details
      outlined
      background-color="rgba(255,255,255,.9)"
      color="rgba(0,0,0,.6)"
      light
      placeholder="Rechercher"
      class="
        input-style
        font-size-input font-weight-normal
        placeholder-lighter
        input-alternative input-icon
        border
      "
    >
      <template slot="prepend-inner">
        <v-icon color="rgba(0,0,0,.6)" size="1rem">mdi mdi-search</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "SearchField",

  data() {
    return {
      search: "",
    };
  },

  watch: {
    search(nVal) {
      this.$emit("search", nVal);
    },
  },
};
</script>

<style scoped></style>
